import type { ComponentChildren } from "preact";
import { cx } from "../cx";

export interface OptionCardProps {
  children: ComponentChildren;
  onClick: () => void;
  selected?: boolean;
  /** Visible but not selectable (locked content). Stays focusable so it can be read out. */
  locked?: boolean;
  /** "checkbox" for multi-select groups, "radio" for single choice, "button" for plain actions. */
  role?: "checkbox" | "radio" | "button";
  title?: string;
  ariaLabel?: string;
  class?: string;
}

/** Selectable card (modes, maps, weapons, camos). */
export function OptionCard({
  children,
  onClick,
  selected = false,
  locked = false,
  role = "button",
  title,
  ariaLabel,
  class: cls,
}: OptionCardProps) {
  const toggled = role === "button" ? undefined : selected;
  return (
    <button
      type="button"
      class={cx("card", selected && "is-selected", locked && "is-locked", cls)}
      role={role === "button" ? undefined : role}
      aria-checked={toggled}
      aria-pressed={role === "button" && selected ? true : undefined}
      aria-disabled={locked || undefined}
      aria-label={ariaLabel}
      title={title}
      onClick={() => {
        if (!locked) onClick();
      }}
      data-nav=""
    >
      {children}
    </button>
  );
}
